"use client";

import { useState } from "react";
import { useContent } from "@/components/site/ContentProvider";

/** Phone landscape — suggestion only; does not block the spine. */
export function LandscapeLock() {
  const site = useContent();
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div className="landscape_hint" role="status">
      <p className="landscape_hint_copy">{site.aria.landscapeMessage}</p>
      <button
        type="button"
        className="landscape_hint_dismiss"
        onClick={() => setDismissed(true)}
        aria-label={site.aria.landscapeDismiss}
      >
        {site.aria.landscapeDismiss}
      </button>
    </div>
  );
}
